import { render, staticRenderFns } from "./CampaignForm.vue?vue&type=template&id=4467a4d8"
import script from "./CampaignForm.vue?vue&type=script&lang=js"
export * from "./CampaignForm.vue?vue&type=script&lang=js"
import style0 from "./CampaignForm.vue?vue&type=style&index=0&id=4467a4d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports